<loading-overlay [isLoading]="isLoading() > 0" />

<p-panel [header]="'Production_Card_Move_To_Batch_TransferUnitsAndRolls' | translateWF: 'Transfer Units & Rolls'">
  <ng-template pTemplate="icons">
    @if (readonly()) {
      <p-toggleButton
        [formControl]="showOnlyUnbundledControl"
        [onLabel]="'Production_Card_Move_To_Batch_ShowOnlyUnbundled' | translateWF: 'Show Only Unbundled'"
        [offLabel]="'Production_Card_Move_To_Batch_ShowAllRolls' | translateWF: 'Show All Rolls'"
        onIcon="pi-filter"
        offIcon="pi pi-filter-slash"
      />
      @if (canAddFromGreige) {
        @if (rollsAvailableForReturn().length > 0) {
          <p-button
            [label]="'Production_Card_Move_To_Batch_ReturnRolls' | translateWF: 'Return Rolls to Greige'"
            icon="pi pi-undo"
            severity="warn"
            (onClick)="openReturnRollsModal()"
          />
        }
        <p-button
          [label]="'Production_Card_Move_To_Batch_ReAddFromGreige' | translateWF: 'Add from Greige to Batching'"
          icon="pi pi-replay"
          severity="success"
          (onClick)="openReAddFromGreigeModal()"
        />
      }
    }
  </ng-template>

  <div class="col-xs">
    @if (!readonly()) {
      <p-card>
        <div class="col-lg">
          <!--! filters rolls  -->
          <div class="col">
            <p-button
              [label]="'Production_Card_Move_To_Batch_ShowSelectedItems' | translateWF: 'Show Selected Items'"
              (onClick)="getSelectedItems()"
              severity="secondary"
              variant="outlined"
              size="small"
            />

            <div class="grid-auto-4 items-end">
              <div class="form-box">
                <label for="moveToBatchSearchTerm">
                  {{ 'Production_Card_Move_To_Batch_TU_Or_Roll_Number' | translateWF: 'Transfer Unit or Roll Number' }}
                  <i
                    class="pi pi-question-circle text-blue-500"
                    [pTooltip]="'Production_Card_Move_To_Batch_FilterByTURollItemOrItemName' | translateWF: 'Filter by TU, Roll Number, Item or Item-name'"
                  ></i>
                </label>
                <p-autoComplete
                  inputId="moveToBatchSearchTerm"
                  [formControl]="searchTermControl"
                  [dropdown]="false"
                  [suggestions]="[]"
                  [fluid]="true"
                  class="w-full"
                  styleClass="cs-autocomplete-hide-loader"
                />
              </div>

              <div class="form-box">
                <label for="moveToBatchFabricForm">
                  {{ 'Production_Card_Move_To_Batch_FabricForm' | translateWF: 'Fabric Form' }}
                  <i class="pi pi-question-circle text-blue-500" [pTooltip]="'Production_Card_Move_To_Batch_FilterByFabricForm' | translateWF: 'Filter by Fabric Form'"></i>
                </label>
                <p-select
                  inputId="moveToBatchFabricForm"
                  [formControl]="selectedFabricFormControl"
                  [options]="fabricFormOptions()"
                  [showClear]="true"
                  optionLabel="label"
                  optionValue="value"
                  styleClass="w-full"
                />
              </div>
            </div>
          </div>

          <!--! use other work order  -->
          <div class="col">
            <div class="row-start-center">
              <p-checkbox inputId="moveToBatchUseOtherWO" [binary]="true" [formControl]="useOtherWorkOrderControl" />
              <label for="moveToBatchUseOtherWO">
                {{ 'Production_Card_Move_To_Batch_UseOtherWorkOrder' | translateWF: 'Use another Work Order' }}
              </label>
            </div>

            @if (useOtherWorkOrder()) {
              <!-- !search rolls from other work order -->
              <div class="grid-auto-4">
                <p-autoComplete
                  [dropdown]="true"
                  #workOrderSearch="cslServerSearch"
                  [cslServerSearch]="fetchWorkOrders"
                  [suggestions]="workOrderSearch.results()"
                  (onSelect)="onWorkOrderSelected($event)"
                  [placeholder]="'Production_Card_Move_To_Batch_SearchWorkOrder' | translateWF: 'Search work order...'"
                  optionValue="id"
                  optionLabel="orderNumber"
                  styleClass="w-full cs-autocomplete-hide-loader"
                />
              </div>

              @if (selectedOtherWorkOrder()) {
                <div class="form-box">
                  <label>
                    {{ 'Production_Card_Move_To_Batch_TargetFabricCode' | translateWF: 'Target Fabric Code' }}
                  </label>
                  <p-selectbutton [formControl]="selectedFabricCodeForOtherWOControl" [options]="productionCardFabricOptions()" optionLabel="label" optionValue="value" />
                </div>
              }
              <p-selectbutton [formControl]="currentViewControl" [options]="availableViews" optionLabel="label" optionValue="value" />
            }
          </div>
        </div>
      </p-card>
    }

    @if (!showSelectedItemsTable()) {
      @switch (currentView()) {
        @case (WorkOrderView.CurrentWorkOrder) {
          <p-card data-variant="compact">
            <p-treetable
              [value]="readonly() ? selectedTreeData() : treeData()"
              [columns]="cols"
              [selectionMode]="readonly() ? undefined : 'checkbox'"
              [selectionKeys]="selectionKeys()"
              (selectionKeysChange)="onSelectionChange($event)"
              dataKey="key"
              [scrollable]="true"
              [tableStyle]="{ 'min-width': '50rem' }"
              (onNodeExpand)="onNodeExpand($event)"
              (onNodeCollapse)="onNodeCollapse($event)"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for (col of columns; track col.field) {
                    <th>{{ col.header }}</th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                <tr [ttRow]="rowNode" [ttSelectableRow]="!readonly() && rowNode" [class.row-expanded]="rowNode.node.expanded">
                  @for (col of columns; track col.field; let first = $first) {
                    <td>
                      @if (first) {
                        <p-treeTableToggler [rowNode]="rowNode" />
                        @if (!readonly()) {
                          <p-treeTableCheckbox [value]="rowNode" />
                        }
                      }
                      @if (numericCols.has(col.field)) {
                        {{ rowData[col.field] | number: '1.0-2' }}
                      } @else {
                        {{ rowData[col.field] }}
                      }
                    </td>
                  }
                </tr>
              </ng-template>
            </p-treetable>
          </p-card>
        }
        @case (WorkOrderView.OtherWorkOrder) {
          @if (otherWorkOrderRolls().length > 0 && !readonly()) {
            <p-card data-variant="compact">
              <p-treetable
                [value]="otherWorkOrderTreeData()"
                [columns]="cols"
                selectionMode="checkbox"
                [selectionKeys]="otherWorkOrderSelectionKeys()"
                (selectionKeysChange)="onOtherWorkOrderSelectionChange($event)"
                dataKey="key"
                [scrollable]="true"
                [tableStyle]="{ 'min-width': '50rem' }"
                (onNodeExpand)="onNodeExpand($event)"
                (onNodeCollapse)="onNodeCollapse($event)"
              >
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    @for (col of columns; track col.field) {
                      <th>{{ col.header }}</th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
                  <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [class.row-expanded]="rowNode.node.expanded">
                    @for (col of columns; track col.field; let first = $first) {
                      <td>
                        @if (first) {
                          <p-treeTableToggler [rowNode]="rowNode" />
                          <p-treeTableCheckbox [value]="rowNode" />
                        }
                        @if (numericCols.has(col.field)) {
                          {{ rowData[col.field] | number: '1.0-2' }}
                        } @else {
                          {{ rowData[col.field] }}
                        }
                      </td>
                    }
                  </tr>
                </ng-template>
              </p-treetable>
            </p-card>
          } @else {
            <p-panel [header]="'Production_Card_Move_To_Batch_NoItemsInOtherWorkOrder' | translateWF: 'No items available in other work order'" />
          }
        }
        @default {
          <p-panel [header]="'Production_Card_Move_To_Batch_NoViewSelected' | translateWF: 'No view selected'" />
        }
      }
    } @else if (selectedTreeData().length > 0) {
      <p-card data-variant="compact">
        <p-treetable [value]="selectedTreeData()" [columns]="cols" dataKey="key" [scrollable]="true" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track col.field) {
                <th>{{ col.header }}</th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode">
              @for (col of columns; track col.field; let first = $first) {
                <td>
                  @if (first) {
                    <p-treeTableToggler [rowNode]="rowNode" />
                  }
                  @if (numericCols.has(col.field)) {
                    {{ rowData[col.field] | number: '1.0-2' }}
                  } @else if (col.field === 'knittingOrderNumber' && rowData.isFromOtherWorkOrder) {
                    <span class="flex items-center gap-1">
                      {{ rowData[col.field] }}
                      <i
                        class="pi pi-exclamation-triangle text-orange-500"
                        [pTooltip]="'Production_Card_Move_To_Batch_RollFromDifferentWorkOrder' | translateWF: 'Roll from different Work Order'"
                        tooltipPosition="top"
                      ></i>
                    </span>
                  } @else {
                    {{ rowData[col.field] }}
                  }
                </td>
              }
            </tr>
          </ng-template>
        </p-treetable>
      </p-card>
    } @else {
      <p-panel [header]="'Production_Card_Move_To_Batch_NoItemsSelected' | translateWF: 'No items selected'" />
    }
  </div>
</p-panel>
